<template>
  <div id="cancel-insurance-status-modal">
    <el-dialog
      custom-class="cancel-insurance-status-dialog"
      v-model="showModal"
      :close-on-click-modal="false"
      size="small"
      @close="refreshOrderList"
      @open="showModal = true"
    >
      <!-- 头部 -->
      <div class="custom-header">
        <div class="el-dialog__headerbtn" @click="refreshOrderList">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>
      <div class="custom-body">
        <img :src="`https://o.666visa.cn/static/ssqpeer/order/insurance-${type}.png`" class="icon-status" alt="">
        <div class="text-status">{{ type === 'success' ? '退保中' : '退保失败' }}</div>
        <div class="tips-status" >
          <div class="tips-status-li" v-for="(m, mid) in message" :key="mid">
            {{ m }}
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="cancel-insurance-footer">
          <el-button
          class="foot-btn"
          plain
          @click="handleBack"
          >返回首页</el-button
        >
        <el-button
          class="foot-btn"
          type="primary"
          @click="goOrderDetail"
          >查看订单<span>（{{countdown}}s）</span></el-button
        >
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    // 是否打开
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    order: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: '',
    },
    message: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: this.value, // 是否展示
      statusMap: {
        success: '成功',
        fail: '失败',
      },
      countdown: 3, 
      intervalId: null, 
    };
  },
  watch: {
    value(newVal) {
      this.showModal = newVal;
      if (newVal) {
        this.startCountdown();
      } else {
      // 清除计时器，防止倒计时继续运行
        if (this.intervalId) {
          clearInterval(this.intervalId);
          this.intervalId = null;
        }
      }
    },
    showModal(newVal) {
      this.$emit('input', newVal);
    },
  },
  created() {
    this.startCountdown();
  },
  methods: {
    // 确认退保
    goOrderDetail() {
      this.refreshOrderList();
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    // 开始倒计时
    startCountdown() {
      // 如果计时器已经存在，先清除
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      // 只有在模态框打开时才启动倒计时
      if (this.showModal) {
        this.countdown = 3; // 重置倒计时
        this.intervalId = setInterval(() => {
          if (this.countdown <= 1) {
            clearInterval(this.intervalId); // 清除计时器
            this.intervalId = null;
            this.refreshOrderList();
          } else {
            this.countdown -= 1; // 倒计时递减
          }
        }, 1000);
      }
    },

    // 取消操作
    handleBack() {
      this.showModal = false;
      this.$router.push({
        name: 'index',
      });

      // 清除计时器，避免倒计时继续运行
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    // 刷新订单列表
    refreshOrderList() {
      this.showModal = false;
      this.$emit('close');
    },
  },
  beforeDestroy() {
    // 清除定时器，防止内存泄漏
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
};
</script>

<style lang="less">
@import "../../assets/less/variable";

#cancel-insurance-status-modal {
  .cancel-insurance-status-dialog {
    width: 600px;

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0;

      .custom-header {
        height: 60px;
        line-height: 60px;
        display: block;
        padding: 0 24px;

        .el-dialog__close {
          position: absolute;
          right: 24px;
          top: 16px;
          width: 19px;
          height: 19px;
          transform: rotateZ(45deg);
          cursor: pointer;

          &::before {
            content: "";
            display: block;
            width: 19px;
            position: absolute;
            top: 9px;
            left: 0;
            border-top: 1px solid #777;
          }

          &::after {
            content: "";
            display: block;
            height: 19px;
            position: absolute;
            top: 0;
            left: 9px;
            border-left: 1px solid #777;
          }

          &:hover {
            &::before,
            &::after {
              border-color: @main;
            }
          }
        }
      }

      .custom-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon-status{
          width: 156px;
          height: 100px;
          display: block;
          margin-bottom: 24px;
        }
        .text-status{
          font-size: 20px;
          color: #2F333D;
          font-weight: 500;
          line-height: 24px;
          margin-bottom: 12px;
        }
        .tips-status{
          margin: 0 auto 24px;
          width: 390px;
          .tips-status-li{
            font-weight: 400;
            font-size: 18px;
            line-height: 30px;
            color: #91999F;
            text-align: center;
          }
        }
      }
    }

    .el-dialog__footer {
      .cancel-insurance-footer{
        width: 372px;
        margin: 0 auto 17px;
        display: flex;
        justify-content: space-between;
        .foot-btn {
          width: 176px;
          height: 48px;
          border-radius: 4px;
        }
        .el-button--primary{
          background: #599FFF;
          border-color: #599FFF;;
          color: #fff;
        }
        .el-button.el-button--primary.is-plain {
          border-color: #599FFF;
          color: #599FFF;
          background: #fff;
        }
        .el-button.is-disabled{
          opacity: 0.6;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order-list/cancel-insurance-status-modal.vue